import { SupportedFlagTypes } from '@atlassiansox/feature-flag-web-client/src/api/types';

import { FeatureFlagsType } from './allowedFeatureFlags';
import { addOverrides, removeOverrides } from './featureFlagPersistedOverrides';

const getQueryParam = (url?: string): any => {
  // eslint-disable-next-line no-restricted-syntax
  if (!url) {
    return {};
  }
  // eslint-disable-next-line no-restricted-syntax
  const generatedUrl = new URL(url);
  return new URLSearchParams(generatedUrl.search);
};

function parseParamFlag(flag: string): [string, SupportedFlagTypes] {
  const [flagName, rawFlagValue] = flag.split(':');

  // If flag value is not specified, assume it's true.
  let flagValue: SupportedFlagTypes = rawFlagValue ?? 'true';

  // For boolean flags, convert them to real boolean values.
  if (flagValue.toLowerCase() === 'true') {
    flagValue = true;
  } else if (flagValue.toLowerCase() === 'false') {
    flagValue = false;
  }

  return [flagName, flagValue];
}

/*
 * Initialize overriding of feature flags based on query parameters from the URL
 * Multiple FF can be specified with ?ff=<name>:<value>,<other name>:<other value>, e.g.
 * ?ff=databases.frontend.enable-feature:true,databases.frontend.enable-other-feature:some-string
 *
 * It also handles overrides clear, eg: ?ffc=databases.frontend.enable-feature,databases.frontend.enable-other-feature
 * Both parameters can be combined, overrides clearing happens after overrides adding
 */
export const processQueryParamFeatureFlags = (url?: string): void => {
  const queryParams = getQueryParam(url);
  if (!queryParams?.get) {
    return;
  }

  if (queryParams.get('ff')) {
    const paramFlags = queryParams.get('ff').split(',');
    const overrides = paramFlags.reduce((acc: FeatureFlagsType, flag: string) => {
      const [flagName, flagValue] = parseParamFlag(flag);
      acc[flagName] = flagValue;
      return acc;
    }, {});

    addOverrides(overrides);
  }

  if (queryParams.get('ffc')) {
    removeOverrides(queryParams.get('ffc').split(','));
  }
};
